import React, {useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Alert from '@material-ui/lab/Alert';
import {DropzoneAreaBase} from 'material-ui-dropzone'
const useStyles = makeStyles((theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  DialogForm: {
    width: "100%",
    marginTop: "1rem",
    marginBottom: "1rem"
  },
  buttonItem: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: '1rem'
  },
  formItem: {
      paddingBottom: '1rem'
  },
  TextField: {
      width: "100%"
  },
  loading: {
    border: '10px solid #f3f3f3',
    borderRadius: '50%',
    borderTop: '10px solid #3498db',
    width: '100px !important',
    height: '100px',
    animation: '$spin 2s linear infinite'
  },
  '@-webkit-keyframes spin': {
    '0%': {
        webkitTransform: 'rotate(0deg)'
    },
    '100%': {
        webkitTransform: 'rotate(360deg)'
    }
  },
  '@keyframes spin': {
      '0%': {
          transform: 'rotate(0deg)'
      },
      '100%': {
          transform: 'rotate(360deg)'
      }
  }
}));

export default function BulkHornbillJob(props) {
    const classes = useStyles();
    const [csvData, setCSVData] = useState('');
    const [loading, setLoading] = useState();
    const [alert, setAlert] = useState();
    const handleSaveCSV = (files) => {
        var Base64CSVFile = {csv: files[0].data.substr(files[0].data.indexOf(',') + 1)};
        setCSVData(Buffer.from(Base64CSVFile.csv, "base64").toString());
    };
    const updateAssets = () => {
        console.log(csvData);
        setLoading(<Container className={classes.loading}></Container>);
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ csvData
            })
        };
        fetch("https://lapsafeapi.azurewebsites.net/api/bulkincident?HornbillKey=ifDsg6ibXbx6", requestOptions).then(response => response.json()).then((data) => {
            if(data.Message.startsWith("Jobs have now been submitted"))
            {
                setAlert(<Alert severity="success">{data.Message}</Alert>);
            }
            else if(data.Message.startsWith("Jobs have been submitted however, there"))
            {
                setAlert(<Alert severity="warning">{data.Message}</Alert>);
            }
            else
            {
                setAlert(<Alert severity="error">{data.message}</Alert>);
            }
            setLoading();
            setCSVData('');
        });
    };
    return (
        <main className={classes.content}>
            <div className={classes.appBarSpacer} />
            <Container maxWidth={false} className={classes.container}>
                <Paper className={classes.paper}>
                    <Typography variant="h4">Bulk Incident - Hornbill</Typography>
                    <Container className={classes.container} maxWidth={false}>
                        <Grid container>
                            <Grid item className={classes.formItem} xs={12}>
                                <DropzoneAreaBase acceptedFiles={[".csv, text/csv, application/vnd.ms-excel, application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values"]} showPreviews={true} dropzoneText='' filesLimit={1} onAdd={(fileObjs) => handleSaveCSV(fileObjs)}/>
                            </Grid>
                            <Grid item xs={12} className={classes.buttonItem}>
                                <Button  variant="contained" color="primary" type="button" onClick={updateAssets}>Update Assets</Button>
                            </Grid>
                        </Grid>
                    </Container>
                    {loading}
                    {alert}
                </Paper>
            </Container>
        </main>
    )
}
